import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import cx from 'classnames';

import ErrorBoundary from '../errorBoundary/ErrorBoundary';
import PtProgress from '../ptProgress/PtProgress';
import PrimaryNavbar from '../primaryNavbar/PrimaryNavbar';
import Footer from '../footer/Footer';
import styles from './PageLayout.module.css';
import { lessonsPath, coursesPath, projectsPath } from '../../strings';

export const pageWrapperId = 'pageWrapper';
export const mainContentId = 'mainContent';

const PageLayout = () => {
  const { pathname } = useLocation();

  const isScrollingNavPage = new RegExp(
    `/${lessonsPath}|/${projectsPath}|/${coursesPath}/.+`
  ).test(pathname);

  return (
    <div className={styles.app}>
      <a href={`#${mainContentId}`} className={styles.skipLink}>
        Skip to main content
      </a>
      <div id={pageWrapperId} className={styles.pageWrapper}>
        <PrimaryNavbar
          className={cx(styles.nav, {
            [styles.scrollingNav]: isScrollingNavPage,
          })}
        />

        <ErrorBoundary key={pathname}>
          <Suspense
            fallback={
              <div className={styles.pageLoader}>
                <PtProgress />
              </div>
            }
          >
            <main
              id={mainContentId}
              className={cx(styles.mainContent, {
                [styles.mainContentScrollingNav]: isScrollingNavPage,
              })}
              tabIndex={-1}
            >
              <Outlet />
            </main>
          </Suspense>
        </ErrorBoundary>
      </div>
      <Footer />
    </div>
  );
};

export default PageLayout;
